import { defineMessages } from 'react-intl-next';

// This file is currently being used in Error-screen Example as to display error messages
// Any additional message will be show up in the example.

export default defineMessages({
  documentInsertError: {
    id: 'fabric.editor.ai.experience-application.documentInsertError',
    defaultMessage: "We're having trouble inserting the response. Close the dialog and try again.",
    description: 'Message to users that displays when error happens during document insertion.'
  },
  tokenLimitExceeded: {
    id: 'fabric.editor.ai.experience-application.tokenLimitExceeded',
    defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
    description: 'Message to users that displays when their request has exceeded the maximum input or output limit.'
  },
  rateLimitEnforced: {
    id: 'fabric.editor.ai.experience-application.rateLimitEnforced',
    defaultMessage: 'We’ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>.',
    description: 'Message to users that rate limiting has been enforced.'
  },
  apiError: {
    id: 'fabric.editor.ai.experience.apiError',
    defaultMessage: "We couldn\u2019t get a response, please try again.",
    description: "We couldn't get a response due to an api error (ie. the backend responded with an error, or got a timeout)"
  },
  elevateDisabledGenetateError: {
    id: 'fabric.editor.ai.experience.elevateDisabledGenetateError',
    defaultMessage: "Free generate is disabled in Elevate at this time.",
    description: "Message to let internal users know that the free generate editor ai feature is is disabled in Elevate at this time."
  },
  internalServerError: {
    id: 'fabric.editor.ai.experience.internalServerError',
    defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>.",
    description: "We couldn't get a response due to an internal server error."
  },
  inputTooShortError: {
    id: 'fabric.editor.ai.experience.inputTooShortError',
    defaultMessage: "The content is too short to summarize. Please add more and try again.",
    description: "The input was too short to summarize"
  },
  hipaaContentError: {
    id: 'fabric.editor.ai.experience.hipaaContentError',
    defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again.",
    description: "The input contained HIPAA content"
  },
  logoAltText: {
    id: 'fabric.editor.ai.screens.prompt.logoAltText',
    defaultMessage: 'Atlassian Intelligence Logo',
    description: 'Atlassian Intelligence logo alt text of the Prompt screen'
  },
  floatingAiButtonTooltip: {
    id: 'fabric.editor.ai.floatingAiButton.tooltip',
    defaultMessage: 'Tell Atlassian Intelligence to write anything',
    description: 'The tooltip text for the floating button that invokes AI modal'
  }
});